
import { InjectionToken } from '@angular/core';
import { Request, Response } from 'express';

import { Performance as NodePerformance } from 'perf_hooks';
import { LogSink } from './app/providers/logger.service';

export const REQUEST = new InjectionToken<Request>('REQUEST');
export const RESPONSE = new InjectionToken<Response>('RESPONSE');

export const SERVER_HTTP_CLIENT_LOGGER = new InjectionToken<LogSink>('server:logger:http-client');
export const SERVER_CACHE_LOGGER = new InjectionToken<LogSink>('server:logger:cache');
export const SERVER_RENDERER_LOGGER = new InjectionToken<LogSink>('server:logger:renderer');
export const SERVER_PERFORMANCE_LOGGER = new InjectionToken<LogSink>('server:logger:performance');
export const PERFORMANCE = new InjectionToken<Performance | NodePerformance>('api:performance');
export const REFERRER = new InjectionToken<string>('app:referrer');
